import { api } from "./axios";
import { CreateReminderPayload, UpdateReminderPayload } from "../types/reminder";

export const adminRemindersApi = {
  create: (data: CreateReminderPayload) =>
    api.post("/admin/reminders", data),

  update: (id: number, data: UpdateReminderPayload) =>
    api.put(`/admin/reminders/${id}`, data),

  remove: (id: number) =>
    api.delete(`/admin/reminders/${id}`),

  getDue: () =>
    api.get("/admin/reminders/due", {
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
      },
    }),

  markViewed: (id: number) => api.patch(`/admin/reminders/${id}/view`),
};
